// Auto-generated translation for de.
// Source: kennisbank.js, translated via Claude Sonnet on 2026-05-26T10:56:39.780575+00:00.

export const KENNISBANK = {
  "paarden-gezondheid": {
    slug: "paarden-gezondheid",
    category: "Gesundheit",
    title: "Pferdegesundheit — vollständiger Leitfaden",
    lead: "Pferdegesundheit beginnt mit aufmerksamer Beobachtung, strukturierter Dokumentation und dem rechtzeitigen Hinzuziehen von Fachleuten. In diesem Leitfaden erklären wir die Grundlagen: tägliche Signale, Kontrollen, Prävention und wann du den Tierarzt rufst.",
    datePublished: "2026-05-01",
    sections: [
      {
        h: "Was ist Pferdegesundheit?",
        p: "Pferdegesundheit bedeutet mehr als ‚nicht krank sein'. Es geht um ein gut funktionierendes Bewegungsapparat, eine gesunde Verdauung, mentale Balance und regelmäßige Vorsorge. EquiSight unterstützt all diese Säulen in einer einzigen Akte pro Pferd.",
      },
      {
        h: "Tägliche Signale",
        list: [
          "Appetit und Wasseraufnahme",
          "Verhalten im Stall und auf der Weide",
          "Kot (Konsistenz, Häufigkeit)",
          "Haltung und Bewegung",
          "Fell- und Hautzustand",
          "Herzfrequenz und Atmung in Ruhe",
        ],
      },
      {
        h: "Präventives Management",
        p: "Gute Pferdegesundheit basiert größtenteils auf Vorsorge. Halte Impfungen, Entwurmungen, Zahnkontrollen und Hufpflege konsequent nach. EquiSight sendet automatisch Erinnerungen.",
      },
      {
        h: "Wann rufst du den Tierarzt?",
        list: [
          "Kein Fressen oder Trinken (>4 Stunden)",
          "Koliksymptome",
          "Plötzliche Lahmheit",
          "Hohes Fieber (>38,5°C)",
          "Wunden, die nicht aufhören zu bluten",
          "Geburtkomplikationen",
        ],
      },
    ],
    faq: [
      {
        q: "Wie oft muss ein Pferd zum Zahnarzt?",
        a: "Einmal jährlich bei erwachsenen Pferden. Junge Pferde (3–5 Jahre) und Senioren häufiger.",
      },
      {
        q: "Welche Impfungen sind Pflicht?",
        a: "Für KNHS-Turniere ist die Grippeimpfung gemäß Impfschema vorgeschrieben. Tetanus wird dringend empfohlen.",
      },
    ],
    related: [
      "entingen",
      "voeradvies",
      "hoefverzorging",
    ],
  },
  "voeradvies": {
    slug: "voeradvies",
    category: "Ernährung",
    title: "Fütterungsberatung Pferd — Grundregeln und häufige Fehler",
    lead: "Eine gute Ernährung ist die Grundlage der Pferdegesundheit. In diesem Leitfaden: Heu, Kraftfutter, Ergänzungsmittel, Gewicht und der Fruktanindex erklärt.",
    datePublished: "2026-05-02",
    sections: [
      {
        h: "Wie viel Heu braucht ein Pferd?",
        p: "Ein durchschnittliches Pferd benötigt täglich 1,5–2 % seines Körpergewichts an Raufutter (Heu/Silage). Bei einem 500 kg schweren Pferd sind das 7,5–10 kg Heu.",
      },
      {
        h: "Kraftfutter — wann ist es sinnvoll?",
        p: "Kraftfutter ist nur bei intensiver Arbeit, Trächtigkeit, Laktation oder einem besonderen Energiebedarf erforderlich. Viele Pferde erhalten unnötigerweise Kraftfutter, was zu Übergewicht und metabolischen Problemen führt.",
      },
      {
        h: "Ergänzungsmittel",
        list: [
          "Salz/Mineralien (freie Verfügbarkeit)",
          "Magnesium bei Stress / Muskelproblemen",
          "Biotin bei Hufproblemen",
          "Glucosamin bei Gelenkproblemen",
        ],
      },
      {
        h: "Fruktanindex — Vorsicht beim Grasen",
        p: "Besonders morgens im Frühjahr und bei kalten Nächten gefolgt von sonnigen Tagen ist der Fruktangehalt im Gras hoch. Dies birgt ein erhöhtes Risiko für Hufrehe. EquiSight warnt Sie automatisch.",
      },
    ],
    faq: [
      {
        q: "Muss ich immer Kraftfutter geben?",
        a: "Nein. Viele Pferde kommen mit gutem Raufutter und einem Mineralergänzungsmittel gut aus. Kraftfutter nur bei erhöhtem Energiebedarf.",
      },
      {
        q: "Woran erkenne ich, ob mein Pferd Übergewicht hat?",
        a: "Konditionsbewertung (BCS) und Maßband. EquiSight hilft Ihnen, dies zu verfolgen, und gibt Trend-Warnungen aus.",
      },
    ],
    related: [
      "fructaan-index",
      "paarden-gezondheid",
    ],
  },
  "hoefverzorging": {
    slug: "hoefverzorging",
    category: "Hufpflege",
    title: "Hufpflege beim Pferd — was du wissen musst",
    lead: "Kein Huf, kein Pferd. Hufpflege erfordert Konsequenz: Beschlag oder Barhuf, regelmäßige Kontrolle, trockener Stall und gute Ernährung.",
    datePublished: "2026-05-03",
    sections: [
      {
        h: "Wie oft sollte der Hufschmied kommen?",
        p: "Im Durchschnitt alle 6–8 Wochen. Mit Beschlag etwas kürzer, Barhuf kann manchmal länger sein. Halte den Rhythmus regelmäßig ein — EquiSight sendet automatisch Erinnerungen.",
      },
      {
        h: "Beschlag oder Barhuf?",
        p: "Beides ist möglich, abhängig vom Pferd, der Disziplin und den Stall- bzw. Weidebedingungen. Besprich es mit deinem Hufschmied.",
      },
      {
        h: "Anzeichen von Hufproblemen",
        list: [
          "Unregelmäßiger Gang",
          "Pulsierende Arterien",
          "Wärme im Huf",
          "Risse oder Abbröckeln",
          "Stinkender Strahl",
        ],
      },
    ],
    faq: [
      {
        q: "Was macht ein Hufschmied genau?",
        a: "Bearbeiten des Hufs (Korrigieren und Glätten), gegebenenfalls Eisen anpassen oder neu aufschlagen sowie die allgemeine Hufgesundheit beurteilen.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "entingen": {
    slug: "entingen",
    category: "Gesundheit",
    title: "Impfungen Pferd — Schema, Arten und Regeln",
    lead: "Welche Impfungen braucht ein Pferd? Influenza, Tetanus, Rhinopneumonie und West-Nil. Impfschemata und Turnierregeln auf einen Blick.",
    datePublished: "2026-05-04",
    sections: [
      {
        h: "Influenza",
        p: "Erste Serie mit 3 Impfungen (Woche 0, 4, 6 Monate), danach jährlich. Für Turnierteilnahmen verpflichtend, die letzte Impfung darf maximal 6 Monate zurückliegen.",
      },
      {
        h: "Tetanus",
        p: "Erste Serie mit 2 Impfungen (Woche 0 und 4 Wochen), danach alle 2–3 Jahre. Für jedes Pferd dringend empfohlen.",
      },
      {
        h: "Rhinopneumonie (EHV-1/4)",
        p: "Besonders empfohlen in Stallungen mit vielen Pferden sowie für trächtige Stuten. Alle 6 Monate.",
      },
      {
        h: "West-Nil-Virus",
        p: "Empfohlen in Risikogebieten. Jährlich, vor Beginn der Mückensaison.",
      },
    ],
    faq: [
      {
        q: "Was passiert, wenn mein Pferd zu spät geimpft wurde?",
        a: "Bei Influenza muss häufig die Grundimmunisierung neu begonnen werden. EquiSight erinnert Sie rechtzeitig daran.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "fructaan-index": {
    slug: "fructaan-index",
    category: "Ernährung",
    title: "Fructan-Index Pferd — was er ist und wie man ihn nutzt",
    lead: "Was ist der Fructan-Index? Wann ist Gras gefährlich für dein Pferd? Wie du Hufrehe mit Daten und Planung vermeidest.",
    datePublished: "2026-05-05",
    sections: [
      {
        h: "Was ist Fructan?",
        p: "Fructan ist ein Zucker, den Gras speichert. Bei hohen Konzentrationen kann dies zu Fermentation im Dickdarm und damit zu Hufrehe (Laminitis) führen.",
      },
      {
        h: "Wann ist der Fructan-Gehalt hoch?",
        list: [
          "Kalte Nächte + sonnige Tage (Frühling, Herbst)",
          "Früher Morgen",
          "Nach einem Nachtfrost",
          "Gestresstes Gras (nach dem Mähen, Trockenheit, kurz gemäht)",
        ],
      },
      {
        h: "Wie behält man den Überblick?",
        p: "EquiSight berechnet den Fructan-Index pro Weide und warnt bei hohem Risiko. Kombiniere dies mit Weidezeiten für ein optimales Management.",
      },
    ],
    faq: [
      {
        q: "Welche Pferde sind besonders gefährdet?",
        a: "Ponys (vor allem Shetländer und Welsh), übergewichtige Pferde, Pferde mit EMS und Cushing sowie Pferde, die bereits eine Hufrehe hatten.",
      },
    ],
    related: [
      "voeradvies",
      "paarden-gezondheid",
    ],
  },
  "koliek": {
    slug: "koliek",
    category: "Erkrankungen",
    title: "Kolik beim Pferd — Symptome, Ursachen & was zu tun ist",
    lead: "Kolik bedeutet Bauchschmerzen. Bei Pferden ist sie immer ernst zu nehmen — rufen Sie bei Unsicherheit sofort den Tierarzt an. Lesen Sie hier über Symptome, Ursachen und erste Hilfe.",
    datePublished: "2026-05-06",
    sections: [
      {
        h: "Symptome",
        list: [
          "Kein Fressen oder Trinken",
          "Unruhe, Scharren am Boden",
          "Hinlegen und wieder Aufstehen",
          "Auf den Bauch schauen oder treten",
          "Schwitzen ohne Anstrengung",
          "Erhöhte Herzfrequenz (>48/min)",
        ],
      },
      {
        h: "Ursachen",
        list: [
          "Futterumstellungen",
          "Unzureichende Wasserversorgung (besonders im Winter)",
          "Zu viel Kraftfutter",
          "Sandaufnahme",
          "Stress",
          "Wurmbefall",
        ],
      },
      {
        h: "Was tun?",
        p: "Rufen Sie sofort den Tierarzt an. Lassen Sie das Pferd nicht wälzen, wenn es eine schwere Kolik hat. Führen Sie es ruhig spazieren, wenn das möglich ist. Geben Sie kein Futter und kein Wasser, bis der Tierarzt vor Ort ist.",
      },
    ],
    faq: [
      {
        q: "Kann ich Kolik vorbeugen?",
        a: "Teilweise schon: stabiles Raufutter, ausreichend Wasser, genügend Bewegung, regelmäßige Entwurmung und keine plötzlichen Futterumstellungen.",
      },
    ],
    related: [
      "paarden-gezondheid",
      "voeradvies",
    ],
  },
  "droes": {
    slug: "droes",
    category: "Erkrankungen",
    title: "Druse beim Pferd — Symptome, Ansteckung & Isolierung",
    lead: "Druse (Strangles) ist hochansteckend. Schnelles Erkennen und Isolieren sind entscheidend, um einen Ausbruch im Stall zu verhindern.",
    datePublished: "2026-05-07",
    sections: [
      {
        h: "Symptome",
        list: [
          "Fieber (>39°C)",
          "Fressunlust",
          "Schwellungen unter dem Kiefer",
          "Eitriger Nasenausfluss",
          "Abszesse, die aufbrechen",
        ],
      },
      {
        h: "Isolierung",
        p: "Verdächtiges Pferd sofort unter Quarantäne stellen. Getrennte Pflege, getrenntes Material, strenge Hygiene. Andere Pferde untersuchen lassen.",
      },
    ],
    faq: [
      {
        q: "Wie lange dauert Druse?",
        a: "In der Regel 2–6 Wochen. Manche Pferde bleiben über die Luftsäcke Träger — untersuchen lassen.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "zomereczeem": {
    slug: "zomereczeem",
    category: "Erkrankungen",
    title: "Sommerekzem beim Pferd — Vorbeugung & Behandlung",
    lead: "Sommerekzem ist eine allergische Reaktion auf den Speichel von Gnitzen (Culicoides). Lesen Sie mehr über Vorbeugung und Behandlung.",
    datePublished: "2026-05-08",
    sections: [
      {
        h: "Symptome",
        list: [
          "Juckreiz, besonders an Mähne und Schweifansatz",
          "Kahlstellen und Krusten",
          "Unruhe abends und morgens",
        ],
      },
      {
        h: "Vorbeugung",
        list: [
          "Ekzemdecke mit Bauchgurt und Kopfteil",
          "Aufstallung zu Stoßzeiten (Sonnenuntergang / -aufgang)",
          "Insektenschutzmittel verwenden",
          "Ventilator im Stall",
          "Abstand von Gewässern halten",
        ],
      },
    ],
    faq: [
      {
        q: "Hilft Ernährung gegen Sommerekzem?",
        a: "Einige Nahrungsergänzungsmittel (Omega-3, Vitamin E) unterstützen Haut und Immunsystem, heilen es jedoch nicht.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
};

export default KENNISBANK;
